import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.832 13.12c.407 1.982.668 6.302.668 10.88 0 4.578-.26 8.898-.664 10.861-.783 4.19-3.733 7.501-7.48 8.384-1.83.474-4.72.755-7.856.755-3.137 0-6.026-.28-7.836-.75-3.768-.888-6.717-4.2-7.496-8.37C7.76 32.898 7.5 28.578 7.5 24c0-4.578.26-8.898.664-10.861.783-4.19 3.732-7.501 7.48-8.384C17.474 4.281 20.363 4 23.5 4c3.13 0 6.015.28 7.846.752 3.763.892 6.707 4.201 7.486 8.368ZM16.5 15a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2h-14Zm0 8a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2h-14Zm0 8a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2h-14Z",
    fill: "currentColor"
  }));
};

var SvgToDo = styled(SvgComponent).withConfig({
  displayName: "ToDo__SvgToDo",
  componentId: "sc-v1qeof-0"
})(["", " ", ""], size, color);
export default SvgToDo;